import React from "react";

const CheckBoxIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <>
      {props["aria-checked"] === true ? (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <title>ionicons-v5-l</title>
          <path d="M48,48V464H464V48ZM218,360.38,137.4,270.81l23.79-21.41,56,62.22L350,153.46,374.54,174Z" />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <rect
            x="0.5"
            y="0.5"
            width="19"
            height="19"
            rx="1.5"
            fill="white"
            stroke="#181717"
          />
        </svg>
      )}
    </>
  );
};

export default CheckBoxIcon;
